import { useEffect } from "react";
import { useAtomValue } from "jotai";
import { themePreferenceAtom } from "../atoms/themeAtom";
/** Keeps <html data-theme> in sync with the stored theme preference. */
export function useApplyTheme() {
    const preference = useAtomValue(themePreferenceAtom);
    useEffect(() => {
        if (preference === "auto") {
            delete document.documentElement.dataset.theme;
        }
        else {
            document.documentElement.dataset.theme = preference;
        }
    }, [preference]);
}
